import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'react-bootstrap';
import Select from '../../../../../modules/react/components/stateful/Select';
import styles from './CTA.scss';

export default class CTANumItems extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      onChange: PropTypes.func.isRequired,
    }),
  };

  onSelectChange = e => this.props.input.onChange(e.value);

  render() {
    const { input: { value } } = this.props;

    const itemOptions = Array.from({ length: 60 }, (_, i) => `${i + 1}`).map(numItem => ({
      label: (
        <div>
          <span>{numItem}</span>
        </div>
      ),
      value: numItem,
    }));

    const numItemsSelectProps = {
      autoBlur: true,
      clearable: false,
      onChange: this.onSelectChange,
      value: value || '3',
      options: itemOptions,
    };

    return (
      <React.Fragment>
        <FormGroup>
          <span className={styles.option}>
            number of items
          </span>
          <Select {...numItemsSelectProps} className={styles.select} />
        </FormGroup>
      </React.Fragment>
    );
  }
}
